import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';

import ApplicantDetailRoute from './components/applicant-detail-route';
import SelectFacilityRoute from './components/select-facility-route';
import UserContext from './utils/user-context';

import Login from './pages/login';
import asyncComponent from './pages/async-component';
import HeaderControl from './components/header-control';

//PACKAGE

// PACKAGE
import packageJson from "../package.json";

import './index.scss';

// code splitting
const Terms = asyncComponent(() => import('./pages/terms'));
const ApplicantDetails = asyncComponent(() => import('./pages/applicant-details'));
const FacilitySelect = asyncComponent(() => import('./pages/facility-select'));
const Reprint = asyncComponent(() => import('./pages/reprint-loa'));
const Download = asyncComponent(() => import('./pages/download-loa'));

export default class extends Component {
  constructor(props) {
    super(props);

    this.setUserContext = this.setUserContext.bind(this);

    this.state = {
      ...JSON.parse(localStorage.getItem("vr_current_user")),
      // eslint-disable-next-line react/no-unused-state
      setUserContext: this.setUserContext,
    };
  }

  setUserContext(contextvalue) {
    this.setState({
      ...contextvalue,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      // Whatever storage mechanism you end up deciding to use.
      localStorage.setItem("vr_current_user", JSON.stringify(this.state))
    }
  }

  render() {
    return (
      <Router basename="/voucher-registration">
        <HeaderControl context={this.state} />
        <div className={this.state.authenticated && `content`}>
          <UserContext.Provider value={this.state}>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/terms" component={Terms} />
              <Route exact path="/reprint-loa" component={Reprint} />
              <ApplicantDetailRoute exact path="/applicant-details" component={ApplicantDetails} />
              <SelectFacilityRoute exact path="/select-facility" component={FacilitySelect} />
              <Route exact path="/download-loa" component={Download} />
            </Switch>
          </UserContext.Provider>
        </div>
        <footer class="ui vertical footer bold-date segment version-footer">v{packageJson.version}</footer>
      </Router>
    );
  }
}
